import { ConfigApi, IdentityApi } from '@backstage/core-plugin-api';
import { MetricsApi } from './metrics-api';
import { TemplateMetrics } from '../../types/metrics';
import { Entity } from '@backstage/catalog-model';

export class MetricsApiClient implements MetricsApi {
  private readonly configApi;
  private readonly identityApi;
  constructor(configApi: ConfigApi, identityApi: IdentityApi) {
    this.configApi = configApi;
    this.identityApi = identityApi;
  }

  async retrieveMetricsInfo(requestedEntity: Entity): Promise<TemplateMetrics> {
    const { token } = await this.identityApi.getCredentials();
    const url = this.configApi.getString('backend.baseUrl');
    const response = await fetch(
      `${url}/api/metricsAlertingInsights/v1/template/metrics`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ entity: requestedEntity }),
      },
    );
    if (!response.ok) {
      throw new Error(
        `Failed to retrieve metrics info, ${response.status} ${response.statusText}`,
      );
    }
    const data = await response.json();
    return data.metrics as TemplateMetrics;
  }
}
